import React from 'react';

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import Search from '@material-ui/icons/Search';

import InputMask from './InputMask';
import CustomDatePicker from '../Pickers/CustomDatePicker';
import CustomTimePicker from '../Pickers/CustomTimePicker';
import CustomDateTimePicker from '../Pickers/CustomDateTimePicker';
import CustomMinutesTimePicker from '../Pickers/CustomMinuteTimePicker';
import AutocompleteInput from '../AutocompleteInput';

class Input extends React.Component {
  state = {
    showPassword: false,
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const { elementType, autoFocus, ...inputProps } = this.props;

    let inputElement = null;
    if (elementType === 'input') {
      inputElement = <TextField {...inputProps} autoFocus={autoFocus} />;
    }
    if (elementType === 'maskedInput') {
      const { mask, InputProps, ...maskedProps } = inputProps;
      inputElement = (
        <TextField
          {...maskedProps}
          InputProps={{
            ...InputProps,
            inputComponent: InputMask,
            inputProps: { mask },
          }}
        />
      );
    }
    if (elementType === 'passwordToggle') {
      inputElement = (
        <TextField
          {...inputProps}
          type={this.state.showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      );
    }
    if (elementType === 'select') {
      const {
        options, onBlur, selectedItem, ...selectProps
      } = inputProps;
      inputElement = (
        <TextField style={{ textAlign: 'left' }} {...selectProps} select>
          <MenuItem> <em>{selectedItem}</em> </MenuItem>
          {options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.displayValue}
            </MenuItem>
          ))}
        </TextField>
      );
    }

    if (elementType === 'datePicker') {
      const { onChange, isFormik, ...dateProps } = inputProps;

      inputElement = (
        <CustomDatePicker
          {...dateProps}
          onChange={
            isFormik
              ? (event) => {
                onChange(dateProps.name, event, true);
              }
              : onChange
          }
        />
      );
    }

    if (elementType === 'timePicker') {
      const { onChange, isFormik, ...timeProps } = inputProps;
      inputElement = (
        <CustomTimePicker
          {...timeProps}
          onChange={
            isFormik
              ? (event) => {
                onChange(timeProps.name, event);
              }
              : onChange
          }
        />
      );
    }

    if (elementType === 'minuteTimePicker') {
      const { onChange, isFormik, ...timeProps } = inputProps;
      inputElement = (
        <CustomMinutesTimePicker
          {...timeProps}
          onChange={
            isFormik
              ? (event) => {
                onChange(timeProps.name, event);
              }
              : onChange
          }
        />
      );
    }

    if (elementType === 'dateTimePicker') {
      const { onChange, isFormik, ...timeProps } = inputProps;
      inputElement = (
        <CustomDateTimePicker
          {...timeProps}
          onChange={
            isFormik
              ? (event) => {
                onChange(timeProps.name, event);
              }
              : onChange
          }
        />
      );
    }

    if (elementType === 'search') {
      const { handleSearch, loading, ...selectProps } = inputProps;
      inputElement = (
        <TextField
          {...selectProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{
                loading ? (
                  <CircularProgress size={30} />
                ) : (
                  <IconButton onClick={handleSearch}>
                    <Search />
                  </IconButton>
                )
              }
              </InputAdornment>
            ),
          }}
        />
      );
    }

    if (elementType === 'autocomplete') {
      const {
        onChange,
        name, value,
        searchFunction,
        instruction,
        label,
        disabled,
      } = inputProps;

      inputElement = (
        <AutocompleteInput
          onChange={onChange}
          name={name}
          label={label}
          value={value}
          searchFunction={searchFunction}
          instruction={instruction}
          disabled={disabled}
        />
      );
    }

    if (elementType === 'justificatory') {
      inputElement = (
        <TextField
          {...inputProps}
          type={'text'}
          InputProps={{}}
        />
      );
    }

    return inputElement;
  }
}

export default Input;
